import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import dayjs from 'dayjs';
import { AvailableMapsFieldModel } from 'src/app/models/availableMapsFieldModel';
import { AnalysisManagementService } from 'src/app/services/analysis-management.service';


interface CachedSoilData {
    allMaps: AvailableMapsFieldModel[];
    availableYears: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ChemicalCompareService {

    private cache = new Map<string, CachedSoilData>();
    private chemicalTypes: { type: string, alias: string }[] = [];

    constructor(private analysisManagementService: AnalysisManagementService) {}

    private getCacheKey(fieldId: number, soilType: string): string {
        return `${fieldId}:${soilType}`;
    }

    setChemicalTypes(types: { type: string, alias: string }[]) {
        this.chemicalTypes = types;
    }

    getChemicalTypes(): { type: string, alias: string }[] {
        return this.chemicalTypes;
    }

    loadYearsForSoilType(fieldId: number, soilType: string): Observable<CachedSoilData> {
        const key = this.getCacheKey(fieldId, soilType);
        const cached = this.cache.get(key);
        if (cached) return of(cached);

        const matchingType = this.chemicalTypes.find(t => {
            const lower = t.alias?.toLowerCase() || t.type?.toLowerCase() || '';
            return soilType === 'TOP_SOIL'
                ? lower.includes('chemical') && !lower.includes('sub')
                : lower.includes('sub') && lower.includes('chemical');
        });

        if (!matchingType) return of({ allMaps: [], availableYears: [] });

        return this.analysisManagementService.getAvailableMapsField({
            period: 'all', fieldId, type: matchingType.type, pageSize: 100, pageNumber: 1
        }).pipe(
            map(itemList => {
                const data: CachedSoilData = {
                    allMaps: itemList,
                    availableYears: [...new Set(itemList.map(item => dayjs(item.datePerformed).format('YYYY')))] as string[]
                };
                this.cache.set(key, data);
                return data;
            })
        );
    }

    clearCache() {
        this.cache.clear();
        this.chemicalTypes = [];
    }
}

